import { colors } from '@insurancemenu/imenu-components-lib';
import {
  NavigationClose,
  CheckCircle,
  RadioButtonUnchecked,
  IconCheckmark,
  InfoButton,
  ErrorOutline,
} from '@insurancemenu/imenu-components-lib/dist/icons';
import styled, { CSSProp, css } from 'styled-components';

interface UncheckedButtonIconStylings {
  $color: 'red' | 'yellow' | 'grey' | 'orange';
}

export const RejectedIconStyled = styled(NavigationClose)`
  width: 4rem;
  height: 4rem;
  color: ${colors.red[600]};
`;

export const ApprovedIconStyled = styled(CheckCircle)`
  width: 4rem;
  height: 4rem;
  color: ${colors.green[600]};
`;

export const ErrorOutlineStyled = styled(ErrorOutline)`
  width: 4rem;
  height: 4rem;
  color: ${colors.red[600]};
`;

export const RadioButtonUncheckedStyled = styled(RadioButtonUnchecked)<UncheckedButtonIconStylings>`
  width: 4rem;
  height: 4rem;
  ${({ $color }): CSSProp => {
    switch ($color) {
      case 'yellow':
        return css`
          color: ${colors.yellow[600]};
        `;
      case 'red':
        return css`
          color: ${colors.red[600]};
        `;
      case 'grey':
        return css`
          color: ${colors.neutral[300]};
        `;
      case 'orange':
        return css`
          color: ${colors.orange[600]};
        `;
      default:
        return css`
          color: ${colors.neutral[300]};
        `;
    }
  }}
`;

export const UploadedIconStyled = styled(IconCheckmark)`
  width: 4rem;
  height: 4rem;
  color: ${colors.green[600]};
`;

export const SignedIconStyled = styled(CheckCircle)`
  width: 4rem;
  height: 4rem;
  color: ${colors.indigo[600]};
`;

export const InfoButtonStyled = styled(InfoButton)`
  width: 4rem;
  height: 4rem;
  color: ${colors.neutral[500]};
`;
